import { render, staticRenderFns } from "./TextManagerModal.vue?vue&type=template&id=225ee5e1&scoped=true"
import script from "./TextManagerModal.vue?vue&type=script&lang=js"
export * from "./TextManagerModal.vue?vue&type=script&lang=js"
import style0 from "./TextManagerModal.vue?vue&type=style&index=0&id=225ee5e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225ee5e1",
  null
  
)

export default component.exports